import { Stack, Typography, styled } from '@mui/material';
import { FC } from 'react';

import { useTranslationPrefix } from 'infrastructure/translations/i18n';
import { PrimeFlightIcon } from 'targets/web/components/Icons';
import { componentShadows } from 'targets/web/theme/shadows';

const Divider = styled('div')(({ theme }) => ({
  width: '2px',
  height: 40,
  backgroundColor: theme.palette.divider,
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

const StackWithBackground = styled(Stack)(({ theme }) => ({
  minHeight: 150,
  background: 'linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 100%)',
  backgroundImage: 'url(/assets/portal-banner-bg.png)',
  backgroundRepeat: 'no-repeat',
  backgroundSize: '600px',
  backgroundPosition: 'center right -125px',
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    right: 75,
    width: '400px',
    height: '100%',
    background: 'linear-gradient(75deg, rgba(255,255,255,1) 50px, rgba(255,255,255,0) 275px)',
  },
  [theme.breakpoints.down('md')]: {
    backgroundPosition: 'center right -300px',
    '&::before': {
      right: -100,
    },
  },
}));

const TitleTypography = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    fontSize: '1.25rem',
  },
}));

const CustomerPortalBanner: FC = () => {
  const t = useTranslationPrefix('customer_portal');
  return (
    <StackWithBackground
      width={1}
      justifyContent="left"
      alignItems="center"
      direction="row"
      sx={{
        paddingLeft: 12,
        paddingRight: 12,
        borderRadius: 1,
        backgroundColor: 'background.default',
        boxShadow: componentShadows.card,
      }}
    >
      <Stack
        zIndex={10}
        spacing={{
          xs: 4,
          sm: 6,
        }}
        justifyContent="left"
        alignItems={{
          xs: 'flex-start',
          sm: 'center',
        }}
        direction={{
          xs: 'column',
          sm: 'row',
        }}
      >
        <PrimeFlightIcon width={120} />
        <Divider />
        <TitleTypography variant="h4">{t('banner_title')}</TitleTypography>
      </Stack>
    </StackWithBackground>
  );
};

export default CustomerPortalBanner;
